import type { AuthSettings } from "../store/auth";
import { APPENV } from "../utils/app.environment";

import { betaNaSettings, gammaNaSettings, prodNaSettings } from "./auth.config";

const stagedAuthSettings = () => {
    switch (APPENV.endpoints_stage) {
        case "beta":
            return betaNaSettings;
        case "gamma":
            return gammaNaSettings;
        case "prod":
            return prodNaSettings;
        default:
            return betaNaSettings;
    }
}

export const devSettings: AuthSettings = {
    ...stagedAuthSettings(),
    // aquilaConfig: {
    //     featureAccess: {
    //         configId: "FeatureAccess",
    //         awsAccountId: ""
    //     },
    //     homePageFeedbackForm: {
    //         configId: "HomePageFeedbackForm",
    //         awsAccountId: ""
    //     },
    //     insightDetailFeedbackForm: {
    //         configId: "InsightDetailFeedbackForm",
    //         awsAccountId: ""
    //     }
    // },
    // aquilaApiEndpoint: new EndpointConfiguration(Stage.DEV, Region.IAD, "")
}